export default "assets/images/logo-veynat-c506ad8e.jpg";